module.exports = __webpack_public_path__ + "img/9.a5da8d1e.jpg";